import {getEoschema} from "@/service/e-grid-service";

export default {
    state() {
        return {
            eoschema: []
        }
    },
    mutations: {
        setEosrcEoschemaDict(state, {dictName, data}) {
            state[dictName] = data;
        }
    },
    actions: {
        async loadEosrcEoschema({commit}, payload) {
            const data = await getEoschema(payload);
            if (data && data.result) {
                commit('setEosrcEoschemaDict', {dictName: 'eoschema', data: data.data})
            }
        }
    }
}